import { enableProdMode, importProvidersFrom, LOCALE_ID } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { environment } from "./environments/environment";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { BrowserAnimationsModule, provideAnimations } from "@angular/platform-browser/animations";
import { OAuthModule, OAuthService, OAuthStorage } from "angular-oauth2-oidc";
import { GoogleMapsModule } from "@angular/google-maps";
import { JwtInterceptor } from "./app/authentication/interceptor/jwt.interceptor";
import { RfAuthenticationService } from "./app/authentication/rf-authentication.service";
import { ErrorInterceptor } from "./app/shared/interceptor/error-interceptor/error.interceptor";
import { HttpALDInterceptor } from "./app/shared/interceptor/http-interceptor/http.interceptor";
import { LanguageService } from "./app/shared/service/language-service/language.service";
import { MatDialogModule } from "@angular/material/dialog";
import { MaterialModule } from "./app/shared/module/material.module";
import { provideRouter, withInMemoryScrolling, withRouterConfig } from "@angular/router";
import { routes } from "./app/app-routing.module";
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AngularFireModule } from '@angular/fire/compat';
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { registerLocaleData } from "@angular/common";
import localeIt from '@angular/common/locales/it';
// import "hammerjs";

declare var initMobileApp: Function;
registerLocaleData(localeIt)

if (environment.production) {
  enableProdMode();
}

function cleanHashRedirect(): void {
  const hash = window.location.hash;

  if (
    hash && (
      hash.startsWith('#/support/webform') ||
      hash.startsWith('#/support/webform-reclami') ||
      hash.startsWith('#/maintenance-appointments/service-centers')
    )
  ) {
    const newPath = hash.substring(1);
    window.history.replaceState(null, '', newPath);
  }
}

cleanHashRedirect();

if (!environment.mobile) {
  bootstrapApplication(AppComponent, {
    providers: [
      provideAnimations(),
      provideRouter(routes, withInMemoryScrolling({
        scrollPositionRestoration: 'top'
      }), withRouterConfig({ onSameUrlNavigation: 'reload' })),
      provideHttpClient(withInterceptorsFromDi()),
      OAuthService,
      { provide: OAuthStorage, useValue: window.localStorage },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: HttpALDInterceptor,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: ErrorInterceptor,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: JwtInterceptor,
        multi: true,
      },
      { provide: LOCALE_ID, useValue: 'it-IT' },
      {
        provide: LOCALE_ID,
        deps: [LanguageService],
        useFactory: (languageService: LanguageService) => {
          return languageService.getUsersLocale();
        },
      },
      importProvidersFrom(
        HttpClientModule,
        BrowserAnimationsModule,
        MaterialModule,
        MatDialogModule,
        OAuthModule.forRoot(),
        GoogleMapsModule,
        AngularFireModule.initializeApp(environment.firebase), // Assicurati di passare la tua config
        AngularFireMessagingModule,
        MatSnackBarModule
        // AgmCoreModule.forRoot({
        //   apiKey: "AIzaSyDnqdPlfrk-Vvynkx1vcbA53mKGL4XA1dc",
        //   libraries: ["places"],
        // }),
      )
    ]
  })
    .catch(err => console.error(err));
} else {
  // Cordova Mobile App
  let script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = "cordova.js";
  script.onload = () => {
    document.addEventListener("deviceready", () => {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = "assets/js/mobile.js";
      script.onload = () => {
        bootstrapApplication(AppComponent, {
          providers: [
            provideAnimations(),
            provideRouter(routes, withInMemoryScrolling({
              scrollPositionRestoration: 'top'
            }), withRouterConfig({ onSameUrlNavigation: 'reload' })),
            provideHttpClient(withInterceptorsFromDi()),
            OAuthService,
            { provide: OAuthStorage, useValue: window.localStorage },
            {
              provide: HTTP_INTERCEPTORS,
              useClass: HttpALDInterceptor,
              multi: true,
            },
            {
              provide: HTTP_INTERCEPTORS,
              useClass: ErrorInterceptor,
              multi: true,
            },
            {
              provide: HTTP_INTERCEPTORS,
              useClass: JwtInterceptor,
              multi: true,
              deps: [RfAuthenticationService],
            },
            { provide: LOCALE_ID, useValue: 'it-IT' },
            {
              provide: LOCALE_ID,
              deps: [LanguageService],
              useFactory: (languageService: LanguageService) => {
                return languageService.getUsersLocale();
              },
            },
            importProvidersFrom(
              HttpClientModule,
              BrowserAnimationsModule,
              MaterialModule,
              MatDialogModule,
              OAuthModule.forRoot(),
              GoogleMapsModule,
              AngularFireModule.initializeApp(environment.firebase),
              AngularFireMessagingModule,
              MatSnackBarModule
              // AgmCoreModule.forRoot({
              //   apiKey: "AIzaSyDnqdPlfrk-Vvynkx1vcbA53mKGL4XA1dc",
              //   libraries: ["places"],
              // }),
            )
          ]
        })
          .then(() => initMobileApp())
          .catch(err => console.error(err));
      };
      document.getElementsByTagName('head')[0].appendChild(script);
    }, false);
  };

  document.getElementsByTagName('head')[0].appendChild(script);
}

